import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { Map, icon } from 'leaflet';
import { AuthService } from '../auth.service';
import "leaflet.gridlayer.googlemutant";
import 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/images/marker-icon.png';
import * as $ from 'jquery';
import 'leaflet.locatecontrol';
import { Router } from '@angular/router';
import { CstemapiService } from '../cstemapi.service';
declare var google; 

@Component({
  selector: 'app-areaselection',
  templateUrl: './areaselection.component.html',
  styleUrls: ['./areaselection.component.scss']
})
export class AreaselectionComponent implements OnInit {
  options;
  layers: any = [];
  map;
  marker;
  userLat = 23.040;
  userLong = 78.389;
  userLocation: any = {};
  searchoptions: any = {};
  mpup: any;
  layersControl: any;
  mapOverlays: any;
  flag: boolean = false;
  options1: any;
  layers1: any;
  layersControl1: any;
  loption = {
    position: 'topleft'
  }
  albidoFactor: any = [];
  aFactor;
  albidoObj: any = {};
  popoverMsg: any;

  /*new map */
  geoCoder;

  zoomLevel = 17;
  iconURL: any;
  shadowURL: any;

  constructor(private auth: AuthService, public cstemapi: CstemapiService, private myRoute: Router) {
    this.options = {
      zoom: 5,
      center: L.latLng([this.userLat, this.userLong]),
      // timeDimension: true,
      // timeDimensionControl: true
    };

    this.iconURL = this.cstemapi.assetUrl + 'images/marker-icon.png',
      this.shadowURL = this.cstemapi.assetUrl + 'images/marker-shadow.png'

    this.searchoptions = {
      componentRestrictions: { country: 'IND' }
    }

    var styled = L.gridLayer.googleMutant({
      type: 'roadmap', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });

    var satellite = L.gridLayer.googleMutant({
      type: 'satellite', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });

    var terrain = L.gridLayer.googleMutant({
      type: 'terrain', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });

    this.layers = [styled];

    this.layersControl = {
      baseLayers: {
        'Default': styled,
        'Satellite': satellite,
        'Terrain': terrain
      }
    }

    this.mapOverlays = {
      'Default': styled,
      'Satellite': satellite,
      'Terrain': terrain
    }

    this.getAlbidoFactor();
  }

  ngOnInit() {

    this.aFactor = "4";
    this.auth.saveAlbidoId(4);

    var vm = this;
    $("body").on('click', '#speciallink', function (e) {
      e.preventDefault();
      vm.flag = true;
      if (vm.userLocation['lat'] != undefined) {
        vm.locationDetails();
      }

      // $(".leaflet-right").addClass("leaflet-left");
      // vm.myRoute.navigate(['/location']);
    });
    $("body").on('click', '#resetlink', function (e) {
      e.preventDefault();
      vm.reset();
    });
  }

  onMapReady(map: Map) {
    this.map = map;
    var vm = this;

    // map.addControl(L.control.zoom({ position: 'bottomright' }));
    // map.addControl(L.control.layers(null, this.mapOverlays, { position: 'topleft' }))

    vm.marker = L.marker([this.userLat, this.userLong], {
      icon: icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: this.iconURL,
        shadowUrl: this.shadowURL
      })
    });

    vm.map.addLayer(vm.marker)
    vm.marker.bindPopup("<b>Choose a Location</b>", {
      permanent: true,
      opacity: 1, bottom: '15px'
    }).openPopup();
    vm.map.flyTo([this.userLat, this.userLong], 5);

    L.control.locate({
      strings: {
        title: "Show me where I am, yo!"
      },
      locateOptions: {
        maxZoom: 18,
        enableHighAccuracy: true
      }
    }).addTo(map);

    this.map.on('click', function (e) {
      vm.onMapClick(e)
    });

    var inp = $('#searchbar');
    inp.attr("placeholder", "Enter a place, landmark, locality, etc.").val("").focus().blur();
  }


  handleAddressChange(e) {
    // console.log(e)
    this.userLocation['lat'] = e.geometry.location.lat();
    this.userLocation['long'] = e.geometry.location.lng();
    this.userLocation['name'] = e.name;

    this.auth.saveUserLocation(this.userLocation);

    // console.log(e.name)
    var lat = e.geometry.location.lat();
    var long = e.geometry.location.lng();
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
    this.marker = L.marker([lat, long], {
      icon: icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: this.iconURL,
        shadowUrl: this.shadowURL
      })
    });

    this.map.addLayer(this.marker)
    // this.map.flyTo([lat, long], 15);

    L.popup()
      .setLatLng([lat, long])
      .setContent('<div style="text-align:center"><p style="font-size:15px">Location Selected</p><button style="padding:4px 12px" type="button" class="btn btn-secondary btn-sm" id="speciallink" >Confirm</button><button style="padding:4px 12px; margin-left: 5px;" type="button" class="btn btn-danger btn-sm" id="resetlink" >Reset</button></div>')
      .openOn(this.map);
    this.map.setView([lat, long], this.zoomLevel);
  }

  test(e) {
    // console.log(e)
    // console.log($('#searchbar').val())
    var address = $('#searchbar').val();
    var decimal = /^[-+]?[0-9]+\.[0-9]+$/;
    var digit = /^[0-9 .,]+$/;
    if (address.match(decimal) || address.match(digit)) {

      var vm = this;
      this.geoCoder = new google.maps.Geocoder;
      this.geoCoder.geocode({ 'address': address }, function (results, status) {
        // console.log(results)
        // console.log(status)
        if (status === 'OK') {
          var lat = results[0].geometry.location.lat();
          var long = results[0].geometry.location.lng();
          vm.userLocation.lat = lat;
          vm.userLocation.long = long;
          vm.userLocation.name = results[0].formatted_address;

          vm.auth.saveUserLocation(vm.userLocation);

          // if (status === 'OK') {

          if (vm.marker) {
            vm.map.removeLayer(vm.marker);
          }
          vm.marker = L.marker([lat, long], {
            icon: icon({
              iconSize: [25, 41],
              iconAnchor: [13, 41],
              iconUrl: vm.iconURL,
              shadowUrl: vm.shadowURL
            })
          });

          vm.map.addLayer(vm.marker)
          L.popup()
            .setLatLng([lat, long])
            .setContent('<div style="text-align:center"><p style="font-size:15px">Location Selected</p><button style="padding:4px 12px" type="button" class="btn btn-secondary btn-sm" id="speciallink" >Confirm</button><button style="padding:4px 12px; margin-left: 5px;" type="button" class="btn btn-danger btn-sm" id="resetlink" >Reset</button></div>')
            .openOn(vm.map);
          vm.map.setView([lat, long], vm.zoomLevel);

          // resultsMap.setCenter(results[0].geometry.location);
          // var marker = new google.maps.Marker({
          //   map: resultsMap,
          //   position: results[0].geometry.location
          // });
          // } else {
          //   alert('Geocode was not successful for the following reason: ' + status);
          // }
        } else if (status == 'ZERO_RESULTS') {
          var lat = results[0].geometry.location.lat();
          var long = results[0].geometry.location.lng();
          vm.userLocation.lat = lat;
          vm.userLocation.long = long;
          vm.userLocation.name = '';

          vm.auth.saveUserLocation(vm.userLocation);

          // if (status === 'OK') {

          if (vm.marker) {
            vm.map.removeLayer(vm.marker);
          }
          vm.marker = L.marker([lat, long], {
            icon: icon({
              iconSize: [25, 41],
              iconAnchor: [13, 41],
              iconUrl: vm.iconURL,
              shadowUrl: vm.shadowURL
            })
          });

          vm.map.addLayer(vm.marker)
          L.popup()
            .setLatLng([lat, long])
            .setContent('<div style="text-align:center"><p style="font-size:15px">Location Selected</p><button style="padding:4px 12px" type="button" class="btn btn-secondary btn-sm" id="speciallink" >Confirm</button><button style="padding:4px 12px; margin-left: 5px;" type="button" class="btn btn-danger btn-sm" id="resetlink" >Reset</button></div>')
            .openOn(vm.map);
          vm.map.setView([lat, long], vm.zoomLevel);
        } else {
          alert('Geocode was not successful for the following reason: ' + status);
        }


      });

    }
  }

  onMapClick(e) {
    // console.log(e)
    this.geoCoder = new google.maps.Geocoder;
    this.geoCoder.geocode({ 'location': { lat: e.latlng.lat, lng: e.latlng.lng } }, (results, status) => {
      // console.log(results);
      // console.log(status);
      if (status == 'OK') {
        if (results[0]) {
          this.userLocation['lat'] = e.latlng.lat;
          this.userLocation['long'] = e.latlng.lng;
          this.userLocation['name'] = results[0].formatted_address;
          this.auth.saveUserLocation(this.userLocation);
        }
      } else if (status == 'ZERO_RESULTS') {
        this.userLocation['lat'] = e.latlng.lat;
        this.userLocation['long'] = e.latlng.lng;
        this.userLocation['name'] = '';
        this.auth.saveUserLocation(this.userLocation);
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
    });

    this.map.removeLayer(this.marker)
    this.marker = L.marker([e.latlng.lat, e.latlng.lng], {
      icon: icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: this.iconURL,
        shadowUrl: this.shadowURL
      })
    });


    this.map.addLayer(this.marker)
    this.mpup = L.popup()
      .setLatLng(e.latlng)
      .setContent('<div style="text-align:center"><p style="font-size:15px">Location Selected</p><button style="padding:4px 12px" type="button" class="btn btn-secondary btn-sm" id="speciallink" >Confirm</button><button style="padding:4px 12px; margin-left: 5px;" type="button" class="btn btn-danger btn-sm" id="resetlink" >Reset</button></div>')
      .openOn(this.map);
    // this.map.setView(e.latlng, 8);
    this.map.setView(e.latlng, this.zoomLevel);
  }

  onMapZoomEnd(e) {
    // console.log(this.map.getZoom())
  }

  reset() {
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
    this.map.closePopup();

    this.map.setView([23.040, 78.389], 5);
    this.marker = L.marker([23.040, 78.389], {
      icon: icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: this.iconURL,
        shadowUrl: this.shadowURL
      })
    });
    this.map.addLayer(this.marker);

    var inp = $('#searchbar');
    inp.attr("placeholder", "Enter a place, landmark, locality, etc.").val("").focus().blur();
  }

  locationDetails() {
    this.options1 = {
      zoom: 12,
      center: L.latLng([this.userLocation['lat'], this.userLocation['long']]),
      timeDimension: true,
      timeDimensionControl: true,
      zoomControl: false,
      doubleClickZoom: false,
      scrollWheelZoom: false
    };

    var styled = L.gridLayer.googleMutant({
      type: 'roadmap', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
      styles: [{
        stylers: [{
          saturation: -100 // greyscale map
        }]
      }]
    });

    var styled1 = L.gridLayer.googleMutant({
      type: 'roadmap', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });

    var satellite = L.gridLayer.googleMutant({
      type: 'satellite', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });

    var terrain = L.gridLayer.googleMutant({
      type: 'terrain', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
    });


    this.layers1 = [styled];

    this.layersControl1 = {
      baseLayers: {
        'Default': styled,
        'Road Map': styled1,
        'Satellite': satellite,
        'Terrain': terrain
      }
    }
  }

  onMapReady1(map: Map) {
    this.map = map;
    var vm = this;

    vm.marker = L.marker([this.userLocation['lat'], this.userLocation['long']], {
      icon: L.icon({
        iconSize: [25, 41],
        iconAnchor: [13, 41],
        iconUrl: this.iconURL,
        shadowUrl: this.shadowURL
      })
    });
    vm.map.addLayer(vm.marker)

    // map.panBy([300, 0]);
  }

  getAlbidoFactor() {
    var dObj = {
      userId: this.auth.getUserId()
    };
    var api = 'inputValues/getAlbidoFactor';

    this.cstemapi.cstemAPI(dObj).GetAlbidoFactor.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.albidoFactor = resData.albidoFactorList;
        this.aFactorRangeChange(4);
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting AlbidoFactor Type!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  aFactorRangeChange(id) {
    // console.log(id)
    this.auth.saveAlbidoId(id);
    this.albidoObj = this.albidoFactor.find(alb => alb.albidoFactorId == id);

    this.popoverMsg = 'Range: ' + this.albidoObj.albido_min + '- ' + this.albidoObj.albido_max + ', Default value: ' + this.albidoObj.albido_default;
  }

  goToDashboard() {
    // this.myRoute.navigate(['/dashboard'])
    this.myRoute.navigate(['/appinputs'])
  }

  // geocodeAddress(geocoder, resultsMap) {
  //   var address = document.getElementById('address').value;
  //   geocoder.geocode({'address': address}, function(results, status) {
  //     if (status === 'OK') {
  //       resultsMap.setCenter(results[0].geometry.location);
  //       alert('Geocode was successful for the following reason: ' + status);
  //       // var marker = new google.maps.Marker({
  //       //   map: resultsMap,
  //       //   position: results[0].geometry.location
  //       // });
  //     } else {
  //       alert('Geocode was not successful for the following reason: ' + status);
  //     }
  //   });
  // }
}
